import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cities: [],
};
const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    setCities(state, action) {
      state.cities = action.payload;
    },
    addCity(state, action) {
      state.cities.push(action.payload);
    },
    deleteCity(state, action) {
      state.cities = state.cities.filter(
        (c) => c._id !== action.payload
      );
    },
  },
});

const cityReducer = citySlice.reducer;
const cityActions = citySlice.actions;

export { cityActions, cityReducer };
